import React from "react";
import LandingPageLayout from "../../shared/Layouts/LandingPageLayout";
import { CALENDER_ICON, FRAME_1, FRAME_2 } from "../../assets";

function EvenetDetails() {
  return (
    <LandingPageLayout
      title={
        <>
          SPECIAL COURT SESSION: PRESIDENT OF ENUGU <br /> CUSTOMARY COURT OF
          APPEAL HONOURED FOR <br /> EXEMPLARY SERVICE
        </>
      }
      currentLink="Brief History of the Court of Appeal"
    >
      <div className="w-full flex flex-col lg:flex-row items-start justify-between gap-6 lg:gap-5 py-8 sm:py-12 lg:py-16 px-4 sm:px-8 lg:px-20">
        <div className="flex flex-col gap-y-4 sm:gap-y-5 w-full lg:w-[70vw]">
          <div className="relative">
            <div className="absolute m-3 sm:m-5 z-30 bg-white w-[50px] sm:w-[56px] h-[28px] sm:h-[32px] rounded-md flex items-center justify-center text-globalGreen text-xs sm:text-sm font-medium">
              News
            </div>
            <img
              src={FRAME_1}
              className="w-full h-[200px] sm:h-[220px] lg:h-[250px] object-cover rounded-lg"
              alt="Event Image 1"
            />
          </div>
          <span className="text-primary-300 font-semibold text-xl sm:text-2xl lg:text-[32px] uppercase leading-relaxed">
            A Brief History and Evolution of the <br /> Enugu State Customary
            Court of Appeal
          </span>
          <span className="text-xs sm:text-sm font-medium text-gray-regular text-justify leading-relaxed">
            The Enugu State Customary Court of Appeal is a superior court of
            record established under the Constitution of the Federal Republic of
            Nigeria (1999, as amended). The Court hears appeals from Customary
            Courts within Enugu State and exercises supervisory jurisdiction
            over matters governed by customary law. We are committed to fair,
            timely, and transparent justice in accordance with the customs of
            the people of Enugu State and the Constitution.
          </span>

          <span className="text-xs sm:text-sm font-medium text-gray-regular text-justify leading-relaxed">
            The need to streamline the administration of native law and custom
            and the courts structure, led to the initiation and eventual passage
            of the Federal Capital Territory customary Court Act 2007 that
            created Customary Court, as Courts of first instance with full
            powers to hear and determine causes and matters on Customary laws
            and such other matters as are conferred upon it.
          </span>

          <span className="text-xs sm:text-sm font-medium text-gray-regular text-justify leading-relaxed">
            The Court acknowledged his role in:
          </span>

          <ul className="list-inside list-disc text-xs sm:text-sm font-medium text-gray-regular space-y-1 leading-relaxed">
            <li>Strengthening judicial independence and integrity.</li>
            <li>
              Promoting fair, timely, and culturally relevant adjudication.
            </li>
            <li>
              Expanding access to justice through reforms and digital
              transformation.
            </li>
            <li>
              Ensuring that customary law remains a living and respected source
              of justice in the state.
            </li>
          </ul>
          <div className="relative">
            <div className="absolute m-3 sm:m-5 z-30 bg-white w-[50px] sm:w-[56px] h-[28px] sm:h-[32px] rounded-md flex items-center justify-center text-globalGreen text-xs sm:text-sm font-medium">
              News
            </div>
            <img
              src={FRAME_2}
              className="w-full h-[200px] sm:h-[220px] lg:h-[250px] object-cover rounded-lg"
              alt="Event Image 2"
            />
          </div>
          <span className="text-xs sm:text-sm font-medium text-gray-regular text-justify leading-relaxed">
            The need to streamline the administration of native law and custom
            and the courts structure, led to the initiation and eventual passage
            of the Federal Capital Territory customary Court Act 2007 that
            created Customary Court, as Courts of first instance with full
            powers to hear and determine causes and matters on Customary laws
            and such other matters as are conferred upon it.
          </span>
        </div>
        <div className="w-full lg:w-[450px] p-3 sm:p-4 lg:p-2 rounded-md bg-[#F7F7F7] order-first lg:order-last">
          <span className="text-lg sm:text-xl relative font-semibold pb-0.5 text-globalGreen">
            Latest News
            <div className="w-[70px] sm:w-[89px] absolute border-b-2 border-globalGreen"></div>
          </span>

          <div className="flex items-start flex-col gap-y-3 sm:gap-y-4 mt-4 sm:mt-5">
            {[1, 2, 3].map((_, index) => (
              <div key={index} className="w-full flex gap-x-2 sm:gap-x-3">
                <img
                  src={FRAME_1}
                  className="w-[80px] sm:w-[100px] h-[90px] sm:h-[115px] object-cover rounded-md"
                  alt={`News image ${index + 1}`}
                />
                <div className="flex flex-col gap-y-1 sm:gap-y-2 flex-1">
                  <span className="text-xs sm:text-sm font-semibold leading-relaxed">
                    SPECIAL COURT SESSION: PRESIDENT OF ENUGU CUSTOMARY COURT OF
                    APPEAL HONOURED FOR EXEMPLARY SERVICE
                  </span>
                  <div className="flex items-center gap-x-2">
                    <img
                      src={CALENDER_ICON}
                      className="w-[16px] sm:w-[20px] h-[16px] sm:h-[20px]"
                      alt="Calendar"
                    />
                    <span className="text-xs font-medium text-globalGreen">
                      2025-05-08
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </LandingPageLayout>
  );
}

export default EvenetDetails;
